import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppConfig } from '../../../app.config';
import { AppService } from '../../../app.service';
import { AuthenticationService } from '../../../services/AuthenticationService';

@Component({ standalone: false,
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  constructor(private appService:AppService, private authService:AuthenticationService, private appConfig:AppConfig) { }

  ngOnInit() {
  }

  get compareVisible (){
    return this.appConfig.compareVisible;
  }

  get userCanEditProperties(){
    return this.authService.currentUserValue?.canEditProperties;
  }

  get userCanEditInventory(){
    return this.authService.currentUserValue?.canEditInventory;
  }

  get userCanEditLegalAds(){
    return this.authService.currentUserValue?.canEditLegalAds;
  }

  get userCanAddUsers(){
    return this.authService.currentUserValue?.canAddUsers;
  }

  get userCanBuyProperties(){
    return this.authService.currentUserValue?.canBuyProperties;
  }

  get userCanEditUserSettings(){
    return this.authService.currentUserValue?.canEditUserSettings;
  }

  get userCanEditPlatformSettings(){
    return this.authService.currentUserValue?.canEditPlatformSettings;
  }

  get authenticated(){
    return this.authService.authenticated;
  }

  get userFullName():string|undefined{
    return this.authService.currentUserValue?.fullName;
  }

  get userUsername():string | undefined{
    return this.authService.currentUserValue?.userName;
  }

  get userRole():string | undefined{
    return this.authService.currentUserValue?.role;
  }

  get favoriteProperties(){
    return this.appService.favoriteProperties;
  }

  get comparableProperties(){
    return this.appService.compareProperties;
  }

  get toDoCount(){
    return this.authService.currentUserValue?.unverifiedAgentIds?.length;
  }

  get isSuperAdmin(){
    return this.authService.currentUserValue?.role=='SuperAdmin';
  }

}
